import { useParams } from "react-router-dom";
import {
  Col,
  Container,
  Row
} from "reactstrap";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import AddProductStepOne from "./components/AddProductStepOne";
import { ToastContainer } from "react-toastify";

const BuypassAddProduct = (props: any) => {
  document.title = "Create Product | BuyPass";
  const { id, draftId } = useParams();

  return ( 
    <div className="page-content">
            <ToastContainer />
      
      <Container fluid>
        <BreadCrumb title={id ? "Edit Product" : "Create Product"}  pageTitle="Products"  pageTitleRoute="/manage-products" />
        <Row>
          <Col lg={12}>
            <AddProductStepOne key={id} draftId={draftId ?? ''} productId={id ?? ''} />
          </Col>

          {/* <Col lg={}>

          </Col> */}
        </Row>
      </Container>
    </div>
  );
};

export default BuypassAddProduct;
